import React, { memo } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Icon, Stack, useMediaQuery } from "investira.react.components";
import { PageTemplate } from "../../../components/templates";
import { OUTPUT } from "../../../enums";
import EnquadramentoSettings from "../_settings/EnquadramentoSettings";
import StressTestSettings from "../_settings/StressTestSettings";
import AddEnquadramentoPadrao from "../_components/AddEnquadramentoPadrao";

const ReportSettings = memo((props) => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isUpSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  const OUTPUTS = {
    enquadramento: EnquadramentoSettings,
    stresstest: StressTestSettings,
  };

  const OUTPUTS_ACTIONS = {
    enquadramento: (
      <Stack direction="row" spacing={2}>
        <AddEnquadramentoPadrao callback={props.readEntidadeEnquadramentos} />
        <Button
          variant="contained"
          color="primary"
          startIcon={<Icon iconName="insert" size={16} />}
          size="small"
          sx={{ px: 2 }}
          onClick={() => navigate(`${location.pathname}/add`)}
        >
          {isUpSm ? `Novo ${OUTPUT[params.output].descricao}` : "Novo"}
        </Button>
      </Stack>
    ),
    stresstest: (
      <Stack direction="row" spacing={2}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<Icon iconName="chart_line" size={16} />}
          size="small"
          sx={{ px: 2 }}
          onClick={() => navigate(`${location.pathname}/benchmarks`)}
        >
          {isUpSm ? `Definir Benchmarks` : "Benchmarks"}
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Icon iconName="insert" size={16} />}
          size="small"
          sx={{ px: 2 }}
          onClick={() => navigate(`${location.pathname}/add`)}
        >
          {isUpSm ? `Novo Cenário` : "Cenário"}
        </Button>
      </Stack>
    ),
  };

  const SettingsComponent = OUTPUTS[params.output];
  const { title, subtitle, maxWidth } = OUTPUT[params.output].config;

  return (
    <PageTemplate
      title={title}
      subtitle={subtitle}
      scrollable={true}
      maxWidth={maxWidth}
      headerRenderActions={OUTPUTS_ACTIONS[params.output]}
    >
      <SettingsComponent {...props} />
    </PageTemplate>
  );
});

ReportSettings.displayName = "ReportSettings";

export default ReportSettings;
